// See https://developers.cloudflare.com/images/image-resizing/responsive-images
const CDN_CGI = "cdn-cgi/image";

export default CDN_CGI;
